import Slider from 'react-slider'

import styles from './salary-input.module.scss'

import type { JSX } from 'react'

type SalaryInputProps = {
  value: number | null
  onChange: (value: number) => void
}

export default function SalaryInput({ value, onChange }: SalaryInputProps): JSX.Element {
  const localeTargets = [
    { label: 'Any', value: 0 },
    { label: '$10,000+', value: 10000 },
    { label: '$20,000+', value: 20000 },
    { label: '$30,000+', value: 30000 },
    { label: '$40,000+', value: 40000 },
    { label: '$50,000+', value: 50000 },
    { label: '$60,000+', value: 60000 },
    { label: '$70,000+', value: 70000 },
    { label: '$80,000+', value: 80000 },
    { label: '$90,000+', value: 90000 },
    { label: '$100,000+', value: 100000 },
  ]
  const marks = localeTargets.map((x) => +x.value)

  return (
    <>
      <div className={styles['salary-title']} id="salary-label">
        Salary <span className={styles['salary-time']}>(per annum)</span>
      </div>
      <div className={styles['slider-wrapper']}>
        <div>
          <Slider
            ariaLabelledby="salary-label"
            data-testid="slider"
            className={styles.slider}
            trackClassName="slider-track"
            onChange={onChange}
            min={0}
            max={marks[marks.length - 1]}
            step={10000}
            marks={marks}
            markClassName={styles['slider-mark']}
            value={value ?? undefined}
            renderThumb={(props): JSX.Element => <div {...props} key={props.key} className={styles['slider-thumb']} />}
          />
        </div>
        <span className={styles['slider-value']}>{localeTargets.find((x) => +x.value === value)?.label}</span>
      </div>
    </>
  )
}
